{
  "title": "Доступ к проекту",
  "intro": "Кто может видеть и менять проект {{name}}. Администраторы видят все проекты; участники — только выданные им, как владельцы или гости.",
  "readOnly": "Менять доступ к проекту могут только администраторы.",
  "add": "Добавить человека",
  "addLead": "Дайте участнику организации доступ к этому проекту.",
  "addSubmit": "Дать доступ",
  "added": "{{name}} получил доступ",
  "person": "Человек",
  "accessColumn": "Доступ",
  "nobodyToAdd": "У всех участников уже есть доступ сюда. Новых людей приглашайте в разделе «Пользователи и доступ».",
  "meaning": {
    "owner": "Полные права в проекте: создавать, менять и удалять ресурсы, консоль, пароли root.",
    "guest": "Только смотрит: ресурсы, дашборд, метрики, активность и расходы. Без изменений."
  },
  "empty": "Доступа пока ни у кого нет",
  "emptyLead": "Администраторы видят этот проект всегда. Добавьте участников, чтобы они могли в нём работать.",
  "makeOwner": "Сделать владельцем",
  "makeGuest": "Сделать гостем",
  "changed": "Доступ {{name}} изменён",
  "adminRow": "Администратор",
  "adminRowReason": "Администраторы видят все проекты; роль меняется в разделе «Пользователи и доступ»",
  "remove": "Убрать доступ",
  "removeTitle": "Убрать {{name}} из проекта {{project}}?",
  "removeHidden": "Проект сразу пропадёт у него: из списков, страниц и живых обновлений.",
  "removeKeep": "Учётная запись и доступ к другим проектам сохраняются.",
  "removed": "{{name}} больше не имеет доступа"
}
